export default "__VITE_ASSET__DGry9xj1__"